import { render } from "./SidebarItem.vue?vue&type=template&id=3723d37c&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=3723d37c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3723d37c"]])

export default __exports__